import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//import tags
import { Link } from 'react-router-dom';

//import resources
import Skeleton from 'react-loading-skeleton';

// //import api
import FetchData from '../../../api/Api';

export default function PartnerItems() {

     //get locale
     const { locale } = useParams();

    //get data
    const [data, setData] = useState(null);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/partners`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            fetchData();
        }

    }, [data]);

    useEffect(()=> {
        setData(null);
    }, [locale])

    return (
        typeof data === 'object' && data !== null ? (
            data.data.map((item, index) => (
                <Link to={item.link} target="_blank" key={index} className='group border border-gray-150 col-span-6 md:col-span-4 lg:col-span-3 p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500 relative flex items-center justify-center'>
                    <img src={`${process.env.REACT_APP_API_URL}/storage/uploads/partners/thumbs/large_${item.img}`} alt={item.link} />
                </Link>
            ))
        ) : (
            <>
                {[1, 2, 3, 4].map((_, index) => (
                    <div key={index} className="group border border-gray-150 col-span-6 md:col-span-4 lg:col-span-3 p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500">
                        <Skeleton height="14rem" />
                    </div>
                ))}
            </>
        )
            
    );
}


